module.exports = __webpack_public_path__ + "img/insert_drive_file.7657c650.svg";